module.exports = require('@udemy/icons')['createIcon']('next');